import React from "react";
import { Grid, Typography, Chip } from "@mui/material";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import FlightLandIcon from "@mui/icons-material/FlightLand";

import { formatConnectionTimes } from "../../utilities/connectionHelpers/connectionsHelpers";
import { compareDates } from "../../utilities/connectionHelpers/dateHelpers";

const TIGHT_WINDOW_MINUTES = 60;

const hasTightOutboundWindow = (connection, selectedFlight) => {
  const { direction, departureTime } = connection;

  if (!direction || direction === "inbound") return false;
  if (!departureTime) return false;

  const sSTA = selectedFlight.sSTA[0];
  if (!sSTA) return false;

  const comparison = compareDates(sSTA, departureTime);

  const differenceMinutes = comparison.differenceMinutes;
  if (differenceMinutes >= 0 && differenceMinutes <= TIGHT_WINDOW_MINUTES)
    return true;

  return false;
};

const StatusIcon = ({ direction }) => {
  return direction === "outbound" ? (
    <FlightTakeoffIcon fontSize={"small"} sx={{ mr: 1 }} />
  ) : (
    <FlightLandIcon fontSize={"small"} sx={{ mr: 1 }} />
  );
};

const ConnectionHeader = React.memo(({ connection, selectedFlight }) => {
  const {
    direction,
    flightNumber,
    from,
    to,
    gate,
    passengers = [],
  } = connection;

  const showTightOutboundBadge = hasTightOutboundWindow(
    connection,
    selectedFlight
  );

  const { chips } = formatConnectionTimes(connection);
  return (
    <Grid container alignItems={"center"} spacing={1}>
      <Grid item>
        <StatusIcon direction={direction} />
      </Grid>
      <Grid item xs zeroMinWidth>
        <Typography variant={"body2"}>
          {from}→{to}
        </Typography>
        <Typography variant={"caption"} color={"text.secondary"}>
          {flightNumber}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant={"caption"}>G:{gate || "N/A"}</Typography>
      </Grid>
      <Grid item>
        {chips.map((c, idx) => (
          <Chip
            key={`chip-${idx}`}
            size={"small"}
            label={c}
            color={showTightOutboundBadge ? "error" : "primary"}
          />
        ))}
      </Grid>
      <Grid item width={55}>
        <Typography variant={"caption"} sx={{ fontWeight: "bold" }}>
          PAX:{passengers.length || "-"}
        </Typography>
      </Grid>
    </Grid>
  );
});

export default ConnectionHeader;
